import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import styled from "styled-components";

const StyledExpansionPanel = styled(ExpansionPanel)`
  box-shadow: none;
`;

export default StyledExpansionPanel;
